import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container container">
        <div className="footer-grid">
          <div className="footer-section">
            <h4>West Drayton Body Works</h4>
            <p>
              Professional car body repair and accident repair services in West Drayton, UK.
            </p>
            <div className="footer-social">
              <a href="https://wa.me/447888396099" className="social-link" title="WhatsApp">
                💬 WhatsApp
              </a>
              <a href="tel:02045793699" className="social-link" title="Call us">
                ☎️ Call
              </a>
              <a href="mailto:support@westdraytonbodyworks.com" className="social-link" title="Email">
                ✉️ Email
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/quote">Get Quote</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul className="contact-info">
              <li>
                <strong>Phone:</strong>
                <a href="tel:02045793699">02045793699</a>
              </li>
              <li>
                <strong>WhatsApp:</strong>
                <a href="https://wa.me/447888396099">+44 7888 396099</a>
              </li>
              <li>
                <strong>Email:</strong>
                <a href="mailto:support@westdraytonbodyworks.com">support@westdraytonbodyworks.com</a>
              </li>
              <li>
                <strong>Address:</strong>
                <p>Unit 4 The Common<br />West Drayton<br />UB7 7EG, United Kingdom</p>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Hours</h4>
            <ul className="hours">
              <li>Monday - Friday: 9:00 AM - 5:00 PM</li>
              <li>Saturday: 9:00 AM - 3:00 PM</li>
              <li>Sunday: Closed</li>
              <li className="trust-badge">
                <span>✓ Insured & Certified</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p>&copy; {currentYear} West Drayton Body Works Ltd. All rights reserved.</p>
          </div>
          <div className="footer-bottom-right">
            <Link to="/terms">Terms & Conditions</Link>
            <span className="divider">|</span>
            <Link to="/privacy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
